import {
	createRouter,
	createWebHistory,
	createWebHashHistory
} from 'vue-router'
import store from '../store/index'

const routes = [{
		path: '/',
		name: 'layout',
		redirect: '/home',
		component: () => import('@/views/layout.vue'),
		children: [{
			path: '/home',
			name: 'home',
			component: () => import('@/views/home.vue'),
			meta: {
				anonymous: true,
			}
		}]
	},
	{
		path: '/',
		name: 'layout2',
		redirect: '/home',
		component: () => import('@/views/layout2.vue'),
		children: [{
				path: '/list',
				name: 'list',
				component: () => import('@/views/product/list.vue'),
				meta: {
					anonymous: true,
				}
			}, {
				path: '/yi',
				name: 'yi',
				component: () => import('@/views/product/yi.vue'),
				meta: {
					anonymous: true,
				}
			}, {
				path: '/1v1g',
				name: '1v1g',
				component: () => import('@/views/product/1v1g.vue'),
				meta: {
					anonymous: true,
				}
			}, {
				path: '/1v1c',
				name: '1v1c',
				component: () => import('@/views/product/1v1c.vue'),
				meta: {
					anonymous: true,
				}
			}, {
				path: '/da',
				name: 'da',
				component: () => import('@/views/product/da.vue'),
				meta: {
					anonymous: true,
				}
			}, {
				path: '/gao',
				name: 'gao',
				component: () => import('@/views/product/gao.vue'),
				meta: {
					anonymous: true,
				}
			}, {
				path: '/xiao',
				name: 'xiao',
				component: () => import('@/views/product/xiao.vue'),
				meta: {
					anonymous: true,
				}
			}, {
				path: '/xinc',
				name: 'xinc',
				component: () => import('@/views/product/xinc.vue'),
				meta: {
					anonymous: true,
				}
			}, {
				path: '/xing',
				name: 'xing',
				component: () => import('@/views/product/xing.vue'),
				meta: {
					anonymous: true,
				}
			}, {
				path: '/xinx',
				name: 'xinx',
				component: () => import('@/views/product/xinx.vue'),
				meta: {
					anonymous: true,
				}
			}, {
				path: '/ying',
				name: 'ying',
				component: () => import('@/views/product/ying.vue'),
				meta: {
					anonymous: true,
				}
			}, {
				path: '/zhao',
				name: 'zhao',
				component: () => import('@/views/zhao.vue'),
				meta: {
					anonymous: true,
				}
			}, {
				path: '/zhong',
				name: 'zhong',
				component: () => import('@/views/zhong.vue'),
				meta: {
					anonymous: true,
				}
			}, {
				path: '/yizhi',
				name: 'yizhi',
				component: () => import('@/views/yizhi.vue'),
				meta: {
					anonymous: true,
				}
			}, {
				path: '/20220808',
				name: '20220808',
				component: () => import('@/views/news/new1.vue'),
				meta: {
					anonymous: true,
				}
			}, {
				path: '/20220420',
				name: '20220420',
				component: () => import('@/views/news/new2.vue'),
				meta: {
					anonymous: true,
				}
			}, {
				path: '/20220518',
				name: '20220518',
				component: () => import('@/views/news/new3.vue'),
				meta: {
					anonymous: true,
				}
			}, {
				path: '/20200821',
				name: '20200821',
				component: () => import('@/views/news/new4.vue'),
				meta: {
					anonymous: true,
				}
			}, {
				path: '/20220304',
				name: '20220304',
				component: () => import('@/views/news/new5.vue'),
				meta: {
					anonymous: true,
				}
			},
			{
				path: '/20230726',
				name: '20230726',
				component: () => import('@/views/news/new6.vue'),
				meta: {
					anonymous: true,
				}
			},
			{
				path: '/20240201',
				name: '20240201',
				component: () => import('@/views/news/new7.vue'),
				meta: {
					anonymous: true,
				}
			},
			{
				path: '/20240223',
				name: '20240223',
				component: () => import('@/views/news/new8.vue'),
				meta: {
					anonymous: true,
				}
			},
			{
				path: '/20240327',
				name: '20240327',
				component: () => import('@/views/news/new9.vue'),
				meta: {
					anonymous: true,
				}
			},
			{
				path: '/20240720',
				name: '20240720',
				component: () => import('@/views/news/new10.vue'),
				meta: {
					anonymous: true,
				}
			},
			{
				path: '/20240720-1',
				name: '20240720-1',
				component: () => import('@/views/news/new11.vue'),
				meta: {
					anonymous: true,
				}
			},
			{
				path: '/gaobaoyun',
				name: 'gaobaoyun',
				component: () => import('@/views/news/new12.vue'),
				meta: {
					anonymous: true,
				}
			},
			{
				path: '/test',
				name: 'test',
				component: () => import('@/views/test.vue'),
				meta: {
					anonymous: true,
				}
			}
		]
	},
	{
		path: '/',
		name: 'layout3',
		redirect: '/card',
		component: () => import('@/views/layout3.vue'),
		children: [{
				path: '/card',
				name: 'card',
				component: () => import('@/views/card/card.vue'),
				meta: {
					anonymous: true,
					title: "卡类型"
				}
			},
			{
				path: '/card1',
				name: 'card1',
				component: () => import('@/views/card/card1.vue'),
				meta: {
					anonymous: true,
				}
			},
			{
				path: '/card2',
				name: 'card2',
				component: () => import('@/views/card/card2.vue'),
				meta: {
					anonymous: true,
					title: "选科卡"
				}
			},
			{
				path: '/card3',
				name: 'card3',
				component: () => import('@/views/card/card3.vue'),
				meta: {
					anonymous: true,
					title: "志愿卡"
				}
			},
			{
				path: '/card4',
				name: 'card4',
				component: () => import('@/views/card/card4.vue'),
				meta: {
					anonymous: true,
					title: "提分卡"
				}
			},
			{
				path: '/card5',
				name: 'card5',
				component: () => import('@/views/card/card5.vue'),
				meta: {
					anonymous: true,
					title: "升学卡"
				}
			},
			{
				path: '/card6',
				name: 'card6',
				component: () => import('@/views/card/card6.vue'),
				meta: {
					anonymous: true,
					title: "英语学习卡"
				}
			},
			{
				path: '/card7',
				name: 'card7',
				component: () => import('@/views/card/card7.vue'),
				meta: {
					anonymous: true,
					title: "小鲤鱼学习卡"
				}
			},
			{
				path: '/card8',
				name: 'card8',
				component: () => import('@/views/card/card8.vue'),
				meta: {
					anonymous: true,
					title: "龙门学习卡（初中）"
				}
			},
			{
				path: '/card9',
				name: 'card9',
				component: () => import('@/views/card/card9.vue'),
				meta: {
					anonymous: true,
					title: "龙门学习卡（高中）"
				}
			},
			{
				path: '/card10',
				name: 'card10',
				component: () => import('@/views/card/card10.vue'),
				meta: {
					anonymous: true,
					title: "志愿卡/升学卡使用说明"
				}
			},
			{
				path: '/card11',
				name: 'card11',
				component: () => import('@/views/card/card11.vue'),
				meta: {
					anonymous: true,
					title: "国学与传统文化—教学版"
				}
			},
			{
				path: '/card12',
				name: 'card12',
				component: () => import('@/views/card/card12.vue'),
				meta: {
					anonymous: true,
					title: "国学与传统文化—家庭版"
				}
			},
			{
				path: '/card13',
				name: 'card13',
				component: () => import('@/views/card/card13.vue'),
				meta: {
					anonymous: true,
					title: "国学与传统文化—学生版"
				}
			}
		],
	}

]

const router = createRouter({
	history: createWebHashHistory(), //createWebHistory(process.env.BASE_URL),
	routes
})

function getQueryString(url, name) {
	return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url, name) || [, ""])[1]
		.replace(/\+/g, '%20')) || null
}

router.beforeEach((to, from, next) => {

	//找不到页面
	// if (to.matched.length == 0) {
	// 	return next({
	// 		path: '/404'
	// 	});
	// }

	let cardTitle = '';

	if (to.meta.title) {
		cardTitle = to.meta.title;
	}

	if (to.query.type) {
		switch (to.query.type) {
			case "1":
				cardTitle = "升学卡（选科+提分）";
				break;
			case "2":
				cardTitle = "升学卡（提分+志愿）";
				break;
			case "3":
				cardTitle = "升学卡（选科+提分+志愿）";
				break;
			case "4":
				cardTitle = "升学卡（选科+志愿）";
				break;
		}
	}

	store.commit('set_cardTitle', cardTitle);
	document.title = cardTitle;
	return next();

})

router.afterEach((to, from) => {

})


export default router